import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  private readonly themeSubject = new BehaviorSubject<string>('light');
  theme$ = this.themeSubject.asObservable();

  constructor() {
    if (this.isBrowser) {
      const SAVED_THEME = localStorage.getItem('theme') || 'light';
      this.setTheme(SAVED_THEME);
    }
  }

  setTheme(theme: string): void {
    if (!this.isBrowser) {
      return;
    }

    document.body.classList.remove('light-theme', 'dark-theme');
    document.body.classList.add(`${theme}-theme`);
    localStorage.setItem('theme', theme);
    this.themeSubject.next(theme);
  }

  toggleTheme(): void {
    const CURRENT_THEME = this.themeSubject.value;
    this.setTheme(CURRENT_THEME === 'light' ? 'dark' : 'light');
  }

  getCurrentTheme(): string {
    return this.themeSubject.value;
  }
}
